var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "modal-container" },
    [
      _c("ModalFullScreen", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showNotesModal,
            expression: "!showNotesModal",
          },
        ],
        attrs: {
          size: "md",
          withBgClickEvent: true,
          contentClass: `maxHeightModal ${_vm.showNotesModal ? "hidden" : ""}`,
        },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-between bg-white pr-4 sm:pr-6 pb-3 pl-0",
                  },
                  [
                    _c("h3", { staticClass: "text-lg pt-0.5 font-medium" }, [
                      _vm._v(" Visits "),
                      _c("span", { staticClass: "eventLength" }, [
                        _vm._v("(" + _vm._s(_vm.events?.length) + ")"),
                      ]),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "cursor-pointer flex items-center justify-center absolute top-3 right-3.5",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("close")
                          },
                          mouseover: function ($event) {
                            _vm.isHovered = true
                          },
                          mouseout: function ($event) {
                            _vm.isHovered = false
                          },
                        },
                      },
                      [
                        !_vm.isHovered
                          ? _c("CrossIcon", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                        _vm.isHovered
                          ? _c("CrossIconHover", { staticClass: "h-4 w-4" })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "modal-content" }, [
                  _c(
                    "ul",
                    { staticClass: "eventContainer" },
                    _vm._l(_vm.events, function (event) {
                      return _c(
                        "li",
                        { key: event.title, staticClass: "event-item" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-row justify-between w-full",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "vuecal__event-title mb-4 flex font-normal custom-prefix",
                                  class: event.class,
                                },
                                [
                                  event.status === `OPEN`
                                    ? _c("WarningRed", {
                                        staticClass: "w-3 h-3 mr-2",
                                      })
                                    : _vm._e(),
                                  _vm._v(" " + _vm._s(event.status) + " "),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-row gap-1 items-start font-outfit text-base",
                                },
                                [
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: `Notes${
                                        event.notesCount > 0
                                          ? ` (${event.notesCount})`
                                          : ""
                                      }`,
                                      variant: "black",
                                      size: "calendar",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleShow(event)
                                      },
                                    },
                                  }),
                                  _c("EditTaskAction", {
                                    attrs: {
                                      isIcon: false,
                                      size: "calendar",
                                      projectActivity: event.eventObject,
                                      companyId: _vm.company.id,
                                      currentUserRole: _vm.currentUser.role,
                                      currentUserId: _vm.currentUser.id,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col gap-2 vuecal__event-content",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-row items-center font-outfit text-xs font-normal",
                                },
                                [
                                  _c("ProfileGray", { staticClass: "w-3 h-3" }),
                                  event.title
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-notification-blue ml-3 font-normal",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-primary-black text-xs font-normal",
                                            },
                                            [_vm._v(" Client Name:")]
                                          ),
                                          _vm._v(
                                            " " + _vm._s(event.title) + " "
                                          ),
                                        ]
                                      )
                                    : _c("p", { staticClass: "ml-3" }, [
                                        _vm._v("n/a"),
                                      ]),
                                ],
                                1
                              ),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-row items-center font-outfit text-xs leading-normal text-primary-black",
                                  },
                                  [
                                    _c("ClockIcon", { staticClass: "w-3 h-3" }),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "ml-3 text-xs font-normal",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm
                                                .$moment(event.start)
                                                .format("h:mm A")
                                            ) +
                                            " "
                                        ),
                                        event.end
                                          ? _c("span", [_vm._v(" - ")])
                                          : _vm._e(),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm
                                                .$moment(event.end)
                                                .format("h:mm A")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-row items-top font-outfit text-xs",
                                  },
                                  [
                                    _c("LocationGray", {
                                      staticClass: "w-3 h-3 locationSpacing",
                                    }),
                                    event.location
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ml-3 text-primary-black font-normal",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(event.location) + " "
                                            ),
                                          ]
                                        )
                                      : _c("p", { staticClass: "ml-3" }, [
                                          _vm._v("n/a"),
                                        ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-top font-outfit text-xs mb-3 mt-2 font-normal",
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-brown mb-1 font-normal",
                                      },
                                      [_vm._v("Manager:")]
                                    ),
                                    event.managerFirstName
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex flex-row gap-2",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-row gap-1",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "manager-chips flex flex-row items-center text-left",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white capitalize manager-image hover:text-white hover:border-primary-500",
                                                        style: _vm.bgStyle(
                                                          event,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.initial(
                                                                event,
                                                                true
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          event.managerFirstName
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          event.managerFamilyName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "button",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.messageManager(
                                                      event
                                                    )
                                                  },
                                                  mouseover: function ($event) {
                                                    _vm.isHoveredChat = true
                                                  },
                                                  mouseout: function ($event) {
                                                    _vm.isHoveredChat = false
                                                  },
                                                },
                                              },
                                              [
                                                !_vm.isHoveredChat
                                                  ? _c("ChatIcon", {
                                                      staticClass: "h-4 w-4",
                                                    })
                                                  : _vm._e(),
                                                _vm.isHoveredChat
                                                  ? _c("ChatIcon", {
                                                      staticClass: "h-4 w-4",
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "text-xs font-normal",
                                          },
                                          [_vm._v("n/a")]
                                        ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-top font-outfit text-xs font-normal",
                                  },
                                  [
                                    event.assigneeID
                                      ? [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-brown mb-1 font-normal",
                                            },
                                            [_vm._v("Assignee:")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-row gap-2",
                                            },
                                            [
                                              event.assigneeID
                                                ? _c(
                                                    "RouterLink",
                                                    {
                                                      attrs: {
                                                        to: _vm.contarctorRoute(
                                                          event.assigneeID
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex flex-row gap-1",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "manager-chips flex flex-row items-center text-left",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white capitalize manager-image hover:text-white hover:border-primary-500",
                                                                  style:
                                                                    _vm.bgStyle(
                                                                      event,
                                                                      false
                                                                    ),
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.initial(
                                                                          event,
                                                                          false
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    event.assigneeFirstName
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    event.assigneeFamilyName
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "button",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.message(event)
                                                    },
                                                    mouseover: function (
                                                      $event
                                                    ) {
                                                      _vm.isHoveredChat = true
                                                    },
                                                    mouseout: function (
                                                      $event
                                                    ) {
                                                      _vm.isHoveredChat = false
                                                    },
                                                  },
                                                },
                                                [
                                                  !_vm.isHoveredChat
                                                    ? _c("ChatIcon", {
                                                        staticClass: "h-4 w-4",
                                                      })
                                                    : _vm._e(),
                                                  _vm.isHoveredChat
                                                    ? _c("ChatIcon", {
                                                        staticClass: "h-4 w-4",
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      : [
                                          _c("SuitableResources", {
                                            attrs: {
                                              skillIds: _vm.skillIds(event),
                                              limit: 1,
                                              visitId: event.eventId,
                                              excludeResourceUserId:
                                                _vm.excludeResourceUserId,
                                              companyId: _vm.company.id,
                                            },
                                            on: {
                                              fetchNewActivity:
                                                _vm.visitUpdated,
                                            },
                                          }),
                                        ],
                                  ],
                                  2
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.showNotesModal && _vm.selectedEvent
        ? _c("NotesModal", {
            staticClass: "notes-modal-overlay",
            attrs: {
              name: "modal-lv2",
              currentUser: _vm.currentUser,
              activity: _vm.selectedEvent.eventObject,
              project: _vm.selectedEvent.eventObject.project,
            },
            on: { close: _vm.handleClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }